import { AxiosClient } from "../utils/axios";
import { isEmptyObject } from "../utils/common";
import { message as alertMessage } from "ant-design-vue";
import { signToken } from "../utils/auth";
import Axios from "axios";
import { logError } from "../utils/logError";

alertMessage.config({
  top: "60px",
  duration: 2,
  maxCount: 3,
});

export const state = () => ({
  token: "",
  requestToken: "",
  userToken: "",
  userInfo: {
    info: {
      id: "",
    },
  },
  loggedIn: false,
  authLoading: false,
  listSchoolSaved: [],
  preventRepeat: false,
});

export const mutations = {
  SET_USER_INFO(state, payload) {
    state.userInfo = payload;
    if (!isEmptyObject(payload)) {
      state.loggedIn = true;
      if (payload.info?.name && !payload.isServer) {
        alertMessage.success(`Welcome ${payload.info.name}`);
      }
    } else {
      // alertMessage.success({ content: "Đăng xuất thành công", key: "logout" });
      state.loggedIn = false;
    }
  },
  SET_REQUEST_TOKEN(state, payload) {
    state.requestToken = payload;
  },
  SET_USER_TOKEN(state, payload) {
    state.userToken = payload;
  },
  SET_PREVENT_REPEAT(state, payload) {
    state.preventRepeat = payload;
  },

  SET_TOKEN_VERIFY_REDIRECT(state, payload) {
    state.tokenVerifyRedirect = payload;
  },
  SET_LOADING(state, payload) {
    state.authLoading = payload;
  },

  SET_LIST_SCHOOL_SAVED(state, payload) {
    state.listSchoolSaved = payload;
  },
  REMOVE_SCHOOL_SAVED(state, payload) {
    state.listSchoolSaved = state.listSchoolSaved.filter(
      ({ id }) => id != payload,
    );
  },
  SAVE_SCHOOL(state, payload) {
    if (!payload) return;
    state.listSchoolSaved.unshift(payload);
  },
};

export const actions = {
  async nuxtServerInit(
    { commit, state, dispatch },
    { req, res, redirect, error },
  ) {
    const tokenKey = process.env.TOKEN_KEY;
    const cookieToken = this.$cookies.get(tokenKey);
    const url = process.env.BASE_URL_AUTH_REDIRECT;
    const domain = process.env.BASE_URL_AUTH;

    try {
      // await Axios.get(
      //   "http://eduzonelocal.tuoitre.vn:3000/eduzone/api/auth/get-token-verify?type=nuxtServerInit"
      // );

      // Axios.defaults.withCredentials = true;

      // if (!req?.headers?.cookie || !req?.headers?.cookie?.includes(tokenKey)) {
      //   console.log("No cookie or tokenKey not found in cookie");
      //  logError(data, "Nuxt Server Init3")
      //   return;
      // }
      const { data } = await Axios.get(
        // "http://eduzonelocal.tuoitre.vn:3000/eduzone/api/auth/authenticate",
        `${this.$config.BASE_URL_CLIENT}/api/auth/authenticate`,
        {
          headers: {
            Cookie: req?.headers?.cookie,
          },
          timeout: 5000,
        },
      );

      if (data.data) {
        await commit("SET_USER_INFO", {
          info: data.data,
          isServer: true,
          token: cookieToken,
        });
        const config = {
          BROKER_NAME: process.env.BROKER_NAME,
          BROKER_SECRET_KEY: process.env.BROKER_SECRET_KEY,
        };
        // const chatToken = signToken(cookieToken, config);
        // await commit("Chat/SET_TOKEN", chatToken);
        // await dispatch("Chat/getToxicList", true);
        // await dispatch("SchoolAccount/getUserRole", {
        //   memberId: data.data.id,
        //   isServer: true,
        // });

        // await dispatch("Chat/getProfile");
        // await dispatch("Chat/getListRoom");
      }
    } catch (err) {
      commit("SET_USER_INFO", {});
      logError(err, "Nuxt Server Init3122213123321132");
      if (err?.response?.data) {
        if (
          err.response.data.code != 401 &&
          err.response.data.err != "Thành viên chưa đăng nhập."
        ) {
          logError(err, "Nuxt Server Init");
        }

        // if (err.response.status == 301) {
        //   error({
        //     statusCode: 500,
        //     message: "Website tạm dừng hoạt động",
        //   });
        // }
      } else {
        console.log("Nuxt Server Init Error Without Response", err);
      }
    }
    commit("SET_LOADING", false);
  },

  // Client-side authentication fallback
  async authenticateClient({ commit, state }) {
    try {
      const response = await AxiosClient.get("/eduzone/api/auth/authenticate");
      console.log("Client authenticate response:", response.data);

      if (response.data && response.data.data) {
        commit("SET_USER_INFO", {
          info: response.data.data,
          isServer: false,
        });
        return response.data.data;
      } else {
        commit("SET_USER_INFO", {});
        return null;
      }
    } catch (error) {
      console.log("Client authenticate error:", error);
      commit("SET_USER_INFO", {});
      return null;
    }
  },

  async getToken(store) {
    const PREFIX = "https://mediahub.tuoitre.vn/api/sso_v1/sso/v1";
    try {
      const { data: res } = await AxiosClient.get(`${PREFIX}/token`, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });
      return res;
    } catch (error) {
      if (error.response && error.response.data) return error.response.data;
      return { code: 400, message: "Error getting token" };
    }
  },

  async refreshToken(store, expiredToken) {
    const PREFIX = "https://mediahub.tuoitre.vn/api/sso_v1/sso/v1";
    try {
      const { data: res } = await AxiosClient.get(`${PREFIX}/refresh-token`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${expiredToken}`,
        },
        withCredentials: true,
      });
      if (res.code === 200) {
        store.commit("SET_REQUEST_TOKEN", res.token);
      }
      return res;
    } catch (error) {
      if (error.response && error.response.data) return error.response.data;
      return { code: 400, message: "Error refreshing token" };
    }
  },

  async logout(store) {
    store.commit("SET_LOADING", true);

    const cookieOptions = {
      domain: ".tuoitre.vn",
      path: "/",
      maxAge: 60 * 60 * 24 * 365,
    };

    // Config values mapping
    const COOKIE_TOKEN_KEY =
      process.env.TOKEN_KEY ||
      (this.$config && this.$config.public
        ? this.$config.public.COOKIE_TOKEN_KEY
        : "_sttsid");
    const PREFIX = "https://mediahub.tuoitre.vn/api/sso_v1/sso/v1";
    const SIGN_TOKEN_API =
      typeof AUTHENTICATE_API !== "undefined"
        ? AUTHENTICATE_API.SIGN_TOKEN
        : `${PREFIX}/sign-token`;

    // Auth Tokens
    const requestToken = store.state.requestToken;
    const userToken = store.state.userToken;

    if (requestToken) {
      try {
        const { data: res } = await AxiosClient.post(
          `${PREFIX}/logout`,
          undefined,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${requestToken}`,
            },
            withCredentials: true,
          },
        );

        if (res.code === 200) {
          store.commit("SET_USER_INFO", {});
          store.commit("SET_LIST_SCHOOL_SAVED", []);
          store.commit("SET_REQUEST_TOKEN", res.jwt);
          store.commit("SET_USER_TOKEN", res.token);

          this.$cookies.remove(COOKIE_TOKEN_KEY, cookieOptions);
          // this.$cookies.set(COOKIE_TOKEN_KEY, res.token, cookieOptions);
          this.$cookies.remove("_ttuid", cookieOptions);
          this.$cookies.remove("is_show_ontap", cookieOptions);
          this.$cookies.remove("onetap_widget_cap", cookieOptions);
          this.$cookies.remove("sync_session", cookieOptions);
        } else if (res.code === 401) {
          if (res.type === 12) {
            const { code, token } = await store.dispatch("getToken");
            if (code === 200 && token) {
              store.commit("SET_REQUEST_TOKEN", token);
              return store.dispatch("logout");
            }
          } else {
            const { code, token } = await store.dispatch(
              "refreshToken",
              requestToken,
            );
            if (code === 200 && token) {
              store.commit("SET_REQUEST_TOKEN", token);
              return store.dispatch("logout");
            }
          }
        }
        store.commit("SET_LOADING", false);
        return res;
      } catch (error) {
        store.commit("SET_LOADING", false);
        return {
          code: 400,
          errors: {
            other: "Đã có lỗi xảy ra, vui lòng tải lại trang và thử lại",
          },
          message: "",
          token: "",
          jwt: "",
          status_code: 400,
        };
      }
    } else if (userToken) {
      try {
        const { code, token } = await store.dispatch("refreshToken", userToken);

        if (code === 200 && token) {
          const { data: res } = await AxiosClient.get(SIGN_TOKEN_API, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          });

          store.commit("SET_REQUEST_TOKEN", res.signed);
          return await store.dispatch("logout");
        }
      } catch (e) { }

      store.commit("SET_LOADING", false);
      return {
        code: 400,
        errors: {
          other: "Đã có lỗi xảy ra, vui lòng tải lại trang và thử lại",
        },
        message: "",
        token: "",
        jwt: "",
        status_code: 400,
      };
    } else {
      try {
        const { code, token } = await store.dispatch("getToken");
        if (code === 200) {
          store.commit("SET_REQUEST_TOKEN", token);
          return await store.dispatch("logout");
        }
      } catch (e) { }

      store.commit("SET_USER_INFO", {});
      store.commit("SET_LIST_SCHOOL_SAVED", []);

      this.$cookies.remove(COOKIE_TOKEN_KEY, cookieOptions);
      this.$cookies.remove("_ttuid", cookieOptions);
      this.$cookies.remove("is_show_ontap", cookieOptions);
      this.$cookies.remove("onetap_widget_cap", cookieOptions);

      store.commit("SET_LOADING", false);
      return {
        code: 400,
        errors: {
          other: "Đã có lỗi xảy ra, vui lòng tải lại trang và thử lại",
        },
        message: "",
        token: "",
        jwt: "",
        status_code: 400,
      };
    }
  },

  async logoutRedirect(store) {
    store.commit("SET_LOADING", true);
    try {
      const response = await AxiosClient.get(
        "/eduzone/api/auth/logout-redirect",
      );
      const { code, message } = response.data;
      if (code == 200) {
        store.commit("SET_USER_INFO", {});
        store.commit("SET_LIST_SCHOOL_SAVED", []);
        if (message) {
          alertMessage.success(message);
        }
      } else {
        if (message) {
          alertMessage.error(message);
        }
      }
    } catch (error) {
      logError(error, "logoutRedirect on store");
    }
    store.commit("SET_LOADING", false);
  },

  async getListSchoolSaved(store) {
    store.commit("SET_LOADING", true);
    const memberId = store.state.userInfo?.info?.id;
    if (!memberId) {
      store.commit("SET_LOADING", false);
    } else {
      try {
        const res = await AxiosClient.get(
          `/eduzone/api/auth/school-saved?id=${memberId}`,
        );
        const { code, data } = res.data;
        if (code == 200 || code == 400) {
          store.commit("SET_LIST_SCHOOL_SAVED", data);
        }
      } catch (error) {
        logError(error, "getListSchoolSaved on store");
      }

      store.commit("SET_LOADING", false);
    }
  },

  async saveSchool(store, { schoolId }) {
    store.commit("SET_LOADING", true);
    const memberId = store.state.userInfo?.info?.id;
    if (!memberId) {
      store.commit("SET_LOADING", false);
      if (window && window.openLoginForm) {
        window.openLoginForm();
      }
      return;
    }
    try {
      const res = await AxiosClient.post(`/eduzone/api/auth/school-saved`, {
        member_id: memberId,
        school_id: schoolId,
      });
      const { code } = res.data;
      if (code == 200) {
        store.commit("SAVE_SCHOOL", { id: schoolId });
        alertMessage.success("Lưu trường thành công");
        // store.dispatch("getListSchoolSaved");
      } else {
        alertMessage.error("Lưu trường thất bại");
      }
    } catch (error) {
      logError(error, "saveSchool on store");
      alertMessage.error("Lưu trường thất bại");
    }
    store.commit("SET_LOADING", false);
  },

  async deleteSchoolSaved(store, { schoolId }) {
    store.commit("SET_LOADING", true);
    const memberId = store.state.userInfo?.info?.id;
    if (!memberId) return;

    try {
      const res = await AxiosClient.delete(
        `/eduzone/api/auth/school-saved?member_id=${memberId}&school_id=${schoolId}`,
      );
      const { code } = res.data;
      if (code == 200) {
        store.commit("REMOVE_SCHOOL_SAVED", schoolId);
        alertMessage.success("Xóa trường thành công");
      } else {
        alertMessage.error("Xóa trường thất bại");
      }
    } catch (error) {
      logError(error, "deleteSchoolSaved on store");
      alertMessage.error("Xóa trường thất bại");
    }
    store.commit("SET_LOADING", false);
  },
};
